import { Button, DropdownField, IDropdownValue } from '@cian/components';
import * as React from 'react';

const s = require('../search_filters.css');

interface IProps {
  label?: string;
  multiple?: boolean;
  values: IDropdownValue[];
  popupContentStyle?: string;
  value: string | number | (string | number)[];
  onClick?(): void;
  onChange(value: string | number | (string | number)[]): void;
}

export class OptionalDropdown extends React.Component<IProps> {
  public render() {
    if (this.props.values.length > 1) {
      return (
        <DropdownField
          containerStyle={s['c-several-filters-dropdown-container']}
          buttonStyle={`${s['c-filters-dropdown-button']} ${s['c-filters-field-content-arrow']}`}
          popupStyle={s['c-filters-dropdown']}
          popupContentStyle={this.props.popupContentStyle || s['c-filters-operations-content']}
          valueStyle={s['c-filters-operations-radio-lbl']}
          valueActiveStyle={s['c-filters-dropdown-opened']}
          valueSelectedStyle={s['c-filters-radio-active']}
          multiple={this.props.multiple || false}
          label={this.props.label}
          value={this.props.value}
          onValueChange={(value) => this.props.onChange(value)}
          values={this.props.values}
        />
      );
    } else {
      return (
        <div className={`${s['c-several-filters-dropdown-container']}
                          ${s['c-several-filters-dropdown-container-disabled']}`}>
          <Button
              buttonStyle={`${s['c-filters-dropdown-button']}`}
              onClick={() => this.props.onClick ? this.props.onClick() : null}>
            { this.props.values.length > 0 ? this.props.values[0].label : '' }
          </Button>
        </div>
      );
    }
  }
}
